/* Copyright (c) 2025 Xperi. All Rights Reserved. */
export const GALLERY_UPDATE_CARET_VISIBLE = 'GALLERY_UPDATE_CARET_VISIBLE';
export const GALLERY_UPDATE_GHOST_MODE = 'GALLERY_UPDATE_GHOST_MODE';
